import { intersection } from "lodash";
import { MULTI_PRODUCTS_APPS } from "./application";
import { UserRoleType } from "./user-role-type";

export const requiresApplication = (context, item) => {
    if (!item.application) return true;
    return context.allowedApps.includes(item.application);
};

export const hasAdminRole = ({ user }) => {
    return [UserRoleType.ADMIN, UserRoleType.CLIENT_ADMIN].includes(user.role);
};

export const hasAccessToMonorepo = (context) => {
    return intersection(context.allowedApps, MULTI_PRODUCTS_APPS).length > 0;
};

export const canAccessPositioningBeta = ({ user }) => {
    const ids = user.testingUserIds || [];
    const id = Number(user.id);
    return Number.isInteger(id) && ids.includes(id);
};
